import { useCallback } from 'react';
import { type UseTranslationResponse, useTranslation } from 'react-i18next';

import type { Locale } from './i18n';

export function useIntl() {
  // We keep a single `common` namespace that contains the full tree.
  // Not passing an ns preserves strong key inference from the defaultNS.
  const { t, i18n } = useTranslation();
  const change = useCallback((next: Locale) => i18n.changeLanguage(next), [i18n]);
  const locale = i18n.language as Locale;
  const tc = (key: Parameters<typeof t>[0], count: number, options?: Record<string, unknown>) => {
    const suffix = count === 1 ? '.one' : '.other';
    const pluralKey = (key as string) + suffix;
    return t(pluralKey as unknown as never, { count, ...(options || {}) });
  };
  return { t, tc, locale, change } as const;
}

export type { UseTranslationResponse };
export { useTranslation };
